import "./new_course.css";
import Layout from "../../../layout/index";
import Input from "antd/lib/input";
import Select from "antd/lib/select";
import TextArea from "antd/lib/input/TextArea";
import Button from "antd/lib/button";
import { HiPlus } from "react-icons/hi";
import Checkbox from "antd/lib/checkbox";
import { AiOutlineUpload } from "react-icons/ai";
import { useEffect, useRef, useState } from "react";
import Switch from "antd/lib/switch";
import CloadAdd from "../../../assets/icons/cloudAdd";
import { useNavigate } from "react-router-dom";
import useCourses from "../../../hooks/use_courses";
import {
  CourseLevelsEnum,
  CurrenciesEnum,
  FontSizesEnum,
  LanguagesEnum,
  PromotionsEnum,
} from "../../../utils/enums";
import toast from "react-hot-toast";
import { getIn } from "formik";
import { FiTrash } from "react-icons/fi";
import { formatSize } from "../../../helpers/format_size";
import {
  createCourseSchema,
  createCourseWithPromotionSchema,
} from "../../../utils/schema";
import Tooltip from "antd/lib/tooltip";
import Modal from "antd/lib/modal";
import { IoClose } from "react-icons/io5";
import { useSelector } from "react-redux";
import moment from "moment";
import { MdFormatColorFill } from "react-icons/md";

const NewCourse = () => {
  const navigate = useNavigate();

  const {
    // entity methods
    getCategories,
    getTags,
    // controller methods
    createCourseController,
    // entity states
    categories,
    tags,
    // controller states
    setCreateCourseFormValidation,
    uploadLessonProgress,
    certificatePreview,
    setCertificatePreview,
    placedFields,
    setPlacedFields,
    // modal states
    newCertificateModal,
    setNewCertificateModal,
    // loading states
    loadings,
    getCategoriesLoading,
    getTagsLoading,
  } = useCourses();

  const uploadCertificateRef = useRef();
  const uploadBannerRef = useRef();
  const uploadCoursePreviewRef = useRef();
  const certificateImageRef = useRef();

  const draggingRef = useRef({
    id: null,
    offsetX: 0,
    offsetY: 0,
  });

  const [showValidation, setShowValidation] = useState(false);
  const [selectedFieldId, setSelectedFieldId] = useState(null);
  const [editFontSizeModal, setEditFontSizeModal] = useState(false);
  const [editColorModal, setEditColorModal] = useState(false);

  const userProfile = useSelector((state) => state.app.userProfile);

  const handleUploadCertificate = (e) => {
    if (e.target.files[0]) {
      setCertificatePreview({
        file: e.target.files[0],
        url: URL.createObjectURL(e.target.files[0]),
      });
      setNewCertificateModal(true);
    }
    e.target.value = null;
  };

  const handleUploadBanner = (e) => {
    if (e.target.files[0]) {
      createCourseController.setFieldValue("banner", e.target.files[0]);
    }
    e.target.value = null;
  };

  const handleUploadCoursePreview = (e) => {
    if (e.target.files[0]) {
      createCourseController.setFieldValue("coursePreview", e.target.files[0]);
    }
    e.target.value = null;
  };

  const pointToPercent = (clientX, clientY) => {
    const wrapper = certificateImageRef.current;
    const img = wrapper.querySelector("img");
    const imgRect = img.getBoundingClientRect();

    const xPercent = ((clientX - imgRect.left) / imgRect.width) * 100;
    const yPercent = ((clientY - imgRect.top) / imgRect.height) * 100;

    const clamp = (v) => Math.min(Math.max(v, 0), 100);

    return { x: clamp(xPercent), y: clamp(yPercent) };
  };

  const handleDropOnImage = (e) => {
    e.preventDefault();

    const fieldType = e.dataTransfer.getData("fieldType");
    if (!fieldType) return;

    const text =
      fieldType === "studentName"
        ? userProfile?.fullname
        : moment().format("YYYY-MM-DD");

    const { x, y } = pointToPercent(e.clientX, e.clientY);

    setPlacedFields((prev) => [
      ...prev,
      {
        id: crypto.randomUUID(),
        type: fieldType,
        text,
        x,
        y,
        width: fieldType === "studentName" ? 30 : 22,
        height: fieldType === "studentName" ? 7 : 6,
        fontSize: 48,
        textColor: "#000000",
        textAlign: "center",
        anchor: "center",
      },
    ]);
  };

  const onBoxMouseDown = (e, id) => {
    e.preventDefault(); // stop text selection
    draggingRef.current.id = id;

    // Start tracking mouse move on window
    window.addEventListener("mousemove", onBoxMouseMove);
    window.addEventListener("mouseup", onBoxMouseUp);
  };

  const onBoxMouseMove = (e) => {
    const id = draggingRef.current.id;
    if (!id) return;

    const { x, y } = pointToPercent(e.clientX, e.clientY);

    setPlacedFields((prev) =>
      prev.map((item) => (item.id === id ? { ...item, x, y } : item)),
    );
  };

  const onBoxMouseUp = () => {
    draggingRef.current.id = null;
    window.removeEventListener("mousemove", onBoxMouseMove);
    window.removeEventListener("mouseup", onBoxMouseUp);
  };

  useEffect(() => {
    getCategories();
  }, []);

  useEffect(() => {
    if (
      createCourseController.values.categoryId &&
      createCourseController.values.languegeId
    ) {
      getTags(
        createCourseController.values.categoryId,
        createCourseController.values.languegeId,
      );
      createCourseController.setFieldValue("tagIds", []);
    }
  }, [
    createCourseController.values.categoryId,
    createCourseController.values.languegeId,
  ]);

  useEffect(() => {
    if (!newCertificateModal) {
      setPlacedFields([]);
      setCertificatePreview(null);
      setShowValidation(false);
    }
  }, [newCertificateModal]);

  return (
    <Layout>
      <form
        onSubmit={createCourseController.handleSubmit}
        className="new_course"
      >
        <div className="course_overview">
          {/* page title */}
          <div className="course_overview_title">
            <h3>Course Overview</h3>
            <p>
              This helps learners quickly understand what your course is about
              and decide if it's right for them.
            </p>
          </div>
          {/* form body */}
          <div className="course_overview_container">
            {/* left */}
            <div className="course_overview_left">
              {/* name */}
              <div className="input_title">
                <label>Title</label>
                <Input
                  name="name"
                  id="name"
                  value={createCourseController.values.name}
                  onChange={createCourseController.handleChange}
                  status={
                    createCourseController.touched.name &&
                    createCourseController.errors.name
                      ? "error"
                      : ""
                  }
                  disabled={loadings.createCourse}
                  type="text"
                />
              </div>
              {/* level */}
              <div className="input_Level">
                <label>Level</label>
                <Select
                  value={createCourseController.values.level}
                  onChange={(value) => {
                    createCourseController.setFieldValue("level", value);
                  }}
                  disabled={loadings.createCourse}
                  status={
                    createCourseController.touched.level &&
                    createCourseController.errors.level
                      ? "error"
                      : ""
                  }
                  options={CourseLevelsEnum}
                />
              </div>
              {/* description */}
              <div className="description">
                <label>Description</label>
                <TextArea
                  name="description"
                  id="description"
                  disabled={loadings.createCourse}
                  value={createCourseController.values.description}
                  onChange={createCourseController.handleChange}
                  status={
                    createCourseController.touched.description &&
                    createCourseController.errors.description
                      ? "error"
                      : ""
                  }
                  rows={4}
                />
              </div>
              {/* prices */}
              {createCourseController.values.prices?.map((price, index) => (
                <div
                  key={index}
                  style={
                    index == createCourseController.values.prices.length - 1
                      ? { border: "none" }
                      : {}
                  }
                  className="currency_price"
                >
                  <div
                    style={
                      index > 0
                        ? { width: "calc(50% - 32px)", marginRight: 16 }
                        : {}
                    }
                    className="currency"
                  >
                    <label>Currency</label>
                    <Select
                      options={CurrenciesEnum.map((item) => {
                        return {
                          label: item.label + ` (${item.description})`,
                          value: item.value,
                        };
                      })}
                      value={price.currency}
                      onChange={(value) => {
                        if (
                          createCourseController.values.prices?.find(
                            (o) => o.currency == value,
                          )
                        ) {
                          toast.error("You selected this currency before");
                        } else {
                          let array = [...createCourseController.values.prices];
                          array[index].currency = value;
                          createCourseController.setFieldValue("prices", array);
                        }
                      }}
                      status={
                        getIn(
                          createCourseController.touched,
                          `prices[${index}].currency`,
                        ) &&
                        getIn(
                          createCourseController.errors,
                          `prices[${index}].currency`,
                        )
                          ? "error"
                          : ""
                      }
                      disabled={loadings.createCourse}
                    />
                  </div>
                  <div
                    style={index > 0 ? { width: "calc(50% - 32px)" } : {}}
                    className="price"
                  >
                    <label>Price</label>
                    <Input
                      value={price.price}
                      onChange={(e) => {
                        let array = [...createCourseController.values.prices];
                        array[index].price = e.target.value;
                        createCourseController.setFieldValue("prices", array);
                      }}
                      status={
                        getIn(
                          createCourseController.touched,
                          `prices[${index}].price`,
                        ) &&
                        getIn(
                          createCourseController.errors,
                          `prices[${index}].price`,
                        )
                          ? "error"
                          : ""
                      }
                      disabled={loadings.createCourse}
                      id="price"
                      name="price"
                      type="tel"
                    />
                  </div>
                  {index > 0 ? (
                    <FiTrash
                      style={{
                        color: "red",
                        fontSize: 20,
                        marginTop: "auto",
                        marginBottom: 12,
                        marginLeft: 16,
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        if (!loadings.createCourse) {
                          let array = [...createCourseController.values.prices];
                          array = array.filter((o, ind) => ind != index);
                          createCourseController.setFieldValue("prices", array);
                        }
                      }}
                    />
                  ) : null}
                </div>
              ))}
              {/* add prices field button */}
              <Button
                onClick={() => {
                  let array = [...createCourseController.values.prices];
                  array.push({
                    price: "",
                    currency: null,
                  });
                  createCourseController.setFieldValue("prices", array);
                }}
                disabled={loadings.createCourse}
                className="add_btn"
              >
                <HiPlus />
                <span>Add currency</span>
              </Button>
              {/* category */}
              <div className="create_course_language">
                <label>Category</label>
                <Select
                  options={categories}
                  loading={getCategoriesLoading}
                  value={createCourseController.values.categoryId}
                  onChange={(value) => {
                    createCourseController.setFieldValue("categoryId", value);
                  }}
                  disabled={loadings.createCourse}
                  status={
                    createCourseController.touched.categoryId &&
                    createCourseController.errors.categoryId
                      ? "error"
                      : ""
                  }
                  showSearch={true}
                  filterOption={(input, option) =>
                    option?.label
                      ?.toString()
                      ?.toLowerCase()
                      .includes(input.toLowerCase())
                  }
                />
              </div>
              {/* languegeId */}
              <div className="create_course_language">
                <label>Language</label>
                <Select
                  options={LanguagesEnum}
                  value={createCourseController.values.languegeId}
                  onChange={(value) => {
                    createCourseController.setFieldValue("languegeId", value);
                  }}
                  disabled={loadings.createCourse}
                  status={
                    createCourseController.touched.languegeId &&
                    createCourseController.errors.languegeId
                      ? "error"
                      : ""
                  }
                />
              </div>
              {/* checkboxes */}
              <div className="check_box_upload">
                {/* certificate */}
                <div
                  className="check_box_container"
                  style={
                    createCourseController.values.certificate
                      ? { marginBottom: 72 }
                      : { marginBottom: 0 }
                  }
                >
                  <Checkbox
                    className="certificate_checkbox_wrapper"
                    checked={createCourseController.values.has_certificate}
                    disabled={loadings.createCourse}
                    onChange={(e) => {
                      if (window.innerWidth > 1000) {
                        createCourseController.setFieldValue(
                          "has_certificate",
                          e.target.checked,
                        );
                        if (!e.target.checked) {
                          createCourseController.setFieldValue(
                            "certificate",
                            null,
                          );
                        }
                      } else {
                        toast.error(
                          "Course Certificate option is only available on desktop devices.",
                        );
                      }
                    }}
                  >
                    Course Certificate
                    <span>(Only available on desktop)</span>
                  </Checkbox>
                  {createCourseController.values.has_certificate && (
                    <div className="upload_certificate_btn">
                      <Button
                        onClick={() => {
                          uploadCertificateRef.current.click();
                        }}
                        disabled={loadings.createCourse}
                        icon={<AiOutlineUpload />}
                      >
                        Upload Certificate
                      </Button>
                      <input
                        type="file"
                        onChange={handleUploadCertificate}
                        hidden
                        ref={uploadCertificateRef}
                        accept="image/*"
                      />
                    </div>
                  )}
                  {createCourseController.values.certificate ? (
                    <div>
                      <div>
                        <div>
                          {createCourseController.values.certificate?.name}
                        </div>
                        <div>
                          {formatSize(
                            createCourseController.values.certificate?.size,
                          )}
                        </div>
                      </div>
                      <div
                        onClick={() => {
                          if (!loadings.createCourse) {
                            createCourseController.setFieldValue(
                              "certificate",
                              null,
                            );
                          }
                        }}
                      >
                        <FiTrash />
                      </div>
                    </div>
                  ) : null}
                </div>
                {/* promotion */}
                <div className="promotion_container">
                  <Checkbox
                    disabled={loadings.createCourse}
                    checked={createCourseController.values.has_promotion}
                    onChange={(e) => {
                      createCourseController.setFieldValue(
                        "has_promotion",
                        e.target.checked,
                      );
                      createCourseController.setFieldValue("promotion", {
                        type: PromotionsEnum[0].value,
                        amount: "",
                      });
                      if (e.target.checked == true) {
                        setCreateCourseFormValidation(
                          createCourseWithPromotionSchema,
                        );
                      } else {
                        setCreateCourseFormValidation(createCourseSchema);
                      }
                    }}
                  >
                    Promotion
                  </Checkbox>
                  {createCourseController.values.has_promotion && (
                    <div className="select_input_promotion">
                      <Select
                        onChange={(value) => {
                          createCourseController.setFieldValue("promotion", {
                            ...createCourseController.values.promotion,
                            type: value,
                          });
                        }}
                        disabled={loadings.createCourse}
                        options={PromotionsEnum}
                        value={createCourseController.values.promotion?.type}
                      />
                      <Input
                        suffix={"%"}
                        value={createCourseController.values.promotion.amount}
                        onChange={(e) => {
                          createCourseController.setFieldValue("promotion", {
                            ...createCourseController.values.promotion,
                            amount: e.target.value,
                          });
                        }}
                        status={
                          getIn(
                            createCourseController.touched,
                            "promotion.amount",
                          ) &&
                          getIn(
                            createCourseController.errors,
                            "promotion.amount",
                          )
                            ? "error"
                            : ""
                        }
                        disabled={loadings.createCourse}
                        max={100}
                        min={0}
                        type="number"
                      />
                    </div>
                  )}
                </div>
              </div>
              {/* tagIds */}
              <div className="create_course_tags">
                <label>Tags</label>
                {!createCourseController.values.categoryId ||
                !createCourseController.values.languegeId ? (
                  <Tooltip title="To select tags for your course, you need to select category and language of your course first.">
                    <Select
                      disabled
                      options={tags}
                      placeholder="Select your tags"
                      status={
                        createCourseController.touched.tagIds &&
                        createCourseController.errors.tagIds
                          ? "error"
                          : ""
                      }
                    />
                  </Tooltip>
                ) : (
                  <Select
                    disabled={loadings.createCourse}
                    loading={getTagsLoading}
                    status={
                      createCourseController.touched.tagIds &&
                      createCourseController.errors.tagIds
                        ? "error"
                        : ""
                    }
                    options={
                      createCourseController.values.languegeId == "en"
                        ? tags.map((item) => {
                            return {
                              label: item.translation?.en?.name,
                              value: item.id,
                            };
                          })
                        : tags.map((item) => {
                            return {
                              label: item.translation?.fa?.name,
                              value: item.id,
                            };
                          })
                    }
                    rootClassName={
                      createCourseController.values.languegeId == "fa"
                        ? "select_persian_font"
                        : ""
                    }
                    showSearch={false}
                    value={createCourseController.values.tagIds}
                    onChange={(value) => {
                      createCourseController.setFieldValue("tagIds", value);
                    }}
                    mode="multiple"
                    placeholder="Select your tags"
                  />
                )}
              </div>
              {/* free */}
              <div className="free_course">
                <label>Free Course</label>
                <Switch
                  checked={createCourseController.values.free}
                  onChange={(value) => {
                    createCourseController.setFieldValue("free", value);
                  }}
                  disabled={loadings.createCourse}
                />
              </div>
            </div>
            {/* right */}
            <div className="course_overview_right">
              <div>
                <div className="course_overview_right_title">
                  <h3>Course Banner Image</h3>
                  <p>
                    Upload a high-quality, engaging image that visually
                    represents your course. This banner will be the first visual
                    element potential students see, so choose an image that is
                    professional, on-brand, and compelling enough to encourage
                    them to learn more.
                  </p>
                </div>
                <div className="upload_file">
                  {!createCourseController.values.banner ? (
                    <p className="ant-upload-drag-icon">
                      <CloadAdd />
                    </p>
                  ) : null}
                  <p className="ant-upload-text">
                    {createCourseController.values.banner
                      ? createCourseController.values.banner?.name
                      : "Choose a file from library"}
                  </p>
                  <p className="ant-upload-hint">
                    {createCourseController.values.banner
                      ? formatSize(createCourseController.values.banner?.size)
                      : "Accepted formats: PNG, JPG, JPEG, WEBP"}
                  </p>
                  <Button
                    onClick={() => {
                      uploadBannerRef.current.click();
                    }}
                    disabled={loadings.createCourse}
                    className="browse_file_btn"
                  >
                    Browse file
                  </Button>
                  {createCourseController.values.banner ? (
                    <Button
                      onClick={() => {
                        createCourseController.setFieldValue("banner", null);
                      }}
                      disabled={loadings.createCourse}
                      className="remove_file_btn"
                    >
                      Remove file
                    </Button>
                  ) : null}
                  {createCourseController.values.banner ? (
                    <img
                      src={URL.createObjectURL(
                        createCourseController.values.banner,
                      )}
                      alt={createCourseController.values.banner.name}
                    />
                  ) : null}
                </div>
                <input
                  type="file"
                  onChange={handleUploadBanner}
                  hidden
                  accept="image/*"
                  ref={uploadBannerRef}
                />
              </div>
              <div>
                <div className="course_overview_right_title">
                  <h3>Course Introduction Video</h3>
                  <p>
                    A short video (max 2 minutes) where you introduce yourself,
                    explain the course goals, what students will learn, and why
                    this course is valuable.
                  </p>
                </div>
                <div className="upload_file">
                  {!createCourseController.values.coursePreview ? (
                    <p className="ant-upload-drag-icon">
                      <CloadAdd />
                    </p>
                  ) : null}
                  <p className="ant-upload-text">
                    {createCourseController.values.coursePreview
                      ? createCourseController.values.coursePreview?.name
                      : "Choose a file from library"}
                  </p>
                  <p className="ant-upload-hint">
                    {createCourseController.values.coursePreview
                      ? formatSize(
                          createCourseController.values.coursePreview?.size,
                        )
                      : "Accepted format: MP4"}
                  </p>
                  <Button
                    onClick={() => {
                      uploadCoursePreviewRef.current.click();
                    }}
                    disabled={loadings.createCourse}
                    className="browse_file_btn"
                  >
                    Browse file
                  </Button>
                  {createCourseController.values.coursePreview ? (
                    <Button
                      onClick={() => {
                        createCourseController.setFieldValue(
                          "coursePreview",
                          null,
                        );
                      }}
                      disabled={loadings.createCourse}
                      className="remove_file_btn"
                    >
                      Remove file
                    </Button>
                  ) : null}
                  {createCourseController.values.coursePreview ? (
                    <video
                      src={URL.createObjectURL(
                        createCourseController.values.coursePreview,
                      )}
                      alt={createCourseController.values.coursePreview.name}
                    />
                  ) : null}
                </div>
                <input
                  type="file"
                  onChange={handleUploadCoursePreview}
                  hidden
                  accept="video/mp4"
                  ref={uploadCoursePreviewRef}
                />
              </div>
            </div>
          </div>
        </div>
        {loadings.createCourse && (
          <div
            style={{ marginTop: 0, marginBottom: 16 }}
            className="upload_progressbar"
          >
            <progress value={uploadLessonProgress} max="100"></progress>
            <span> {uploadLessonProgress}%</span>
          </div>
        )}
        {/* form actions */}
        <div className="save_cancel_container">
          <Button
            onClick={() => {
              navigate("/courses");
            }}
            disabled={loadings.createCourse}
            className="cancel_btn"
          >
            Cancel
          </Button>
          <Button
            htmlType="submit"
            loading={loadings.createCourse}
            className="save_btn"
          >
            Save
          </Button>
        </div>
      </form>
      {/* new certificate modal */}
      <Modal
        open={newCertificateModal}
        onCancel={() => {
          setNewCertificateModal(false);
        }}
        footer={null}
        className="certificateModal"
        closeIcon={null}
      >
        <div className="certificate_modal_container">
          <div className="certificate_modal_title">
            <Button
              onClick={() => {
                setNewCertificateModal(false);
              }}
            >
              <IoClose />
            </Button>
            <h3>Create Certificate Sample</h3>
          </div>
          <div className="certificate_modal_content">
            <div>
              <p>Drag and drop variables on certificate image</p>
              <div>
                <div>
                  <label
                    style={
                      showValidation &&
                      !placedFields.find((o) => o.type == "studentName")
                        ? { color: "red" }
                        : {}
                    }
                  >
                    Recipient's name
                  </label>
                  <div>
                    <div
                      draggable={
                        placedFields.find((o) => o.type == "studentName")
                          ? false
                          : true
                      }
                      onDragStart={(e) =>
                        e.dataTransfer.setData("fieldType", "studentName")
                      }
                      style={
                        placedFields.find((o) => o.type == "studentName")
                          ? { cursor: "not-allowed", opacity: 0.5 }
                          : { cursor: "grab" }
                      }
                      className="certificate_variable_item"
                      id={
                        showValidation &&
                        !placedFields.find((o) => o.type == "studentName")
                          ? "certificate_drag_field_error"
                          : ""
                      }
                    >
                      {userProfile?.fullname}
                    </div>
                    {placedFields.find((o) => o.type == "studentName") ? (
                      <div>
                        <div
                          onClick={() => {
                            setSelectedFieldId(
                              placedFields.find((o) => o.type == "studentName"),
                            );
                            setEditFontSizeModal(true);
                          }}
                        >
                          {placedFields.find((o) => o.type == "studentName")
                            ? placedFields.find((o) => o.type == "studentName")
                                ?.fontSize
                            : 16}
                        </div>
                        <div
                          onClick={() => {
                            setSelectedFieldId(
                              placedFields.find((o) => o.type == "studentName"),
                            );
                            setEditColorModal(true);
                          }}
                        >
                          <MdFormatColorFill
                            color={
                              placedFields.find((o) => o.type == "studentName")
                                ? placedFields.find(
                                    (o) => o.type == "studentName",
                                  )?.textColor
                                : "#000000"
                            }
                          />
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
                <div>
                  <label
                    style={
                      showValidation &&
                      !placedFields.find((o) => o.type == "issueDate")
                        ? { color: "red" }
                        : {}
                    }
                  >
                    Date of issue
                  </label>
                  <div>
                    <div
                      draggable={
                        placedFields.find((o) => o.type == "issueDate")
                          ? false
                          : true
                      }
                      onDragStart={(e) =>
                        e.dataTransfer.setData("fieldType", "issueDate")
                      }
                      style={
                        placedFields.find((o) => o.type == "issueDate")
                          ? { cursor: "not-allowed", opacity: 0.5 }
                          : { cursor: "grab" }
                      }
                      className="certificate_variable_item"
                      id={
                        showValidation &&
                        !placedFields.find((o) => o.type == "issueDate")
                          ? "certificate_drag_field_error"
                          : ""
                      }
                    >
                      {moment().format("YYYY-MM-DD")}
                    </div>
                    {placedFields.find((o) => o.type == "issueDate") ? (
                      <div>
                        <div
                          onClick={() => {
                            setSelectedFieldId(
                              placedFields.find((o) => o.type == "issueDate"),
                            );
                            setEditFontSizeModal(true);
                          }}
                        >
                          {placedFields.find((o) => o.type == "issueDate")
                            ? placedFields.find((o) => o.type == "issueDate")
                                ?.fontSize
                            : 16}
                        </div>
                        <div
                          onClick={() => {
                            setSelectedFieldId(
                              placedFields.find((o) => o.type == "issueDate"),
                            );
                            setEditColorModal(true);
                          }}
                        >
                          <MdFormatColorFill
                            color={
                              placedFields.find((o) => o.type == "issueDate")
                                ? placedFields.find(
                                    (o) => o.type == "issueDate",
                                  )?.textColor
                                : "#000000"
                            }
                          />
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
            <div
              className="certificate_image_scroll"
              onDragOver={(e) => e.preventDefault()}
              onDrop={handleDropOnImage}
            >
              <div
                ref={certificateImageRef}
                className="certificate_image_wrapper"
              >
                <img
                  src={certificatePreview?.url}
                  alt="Uploaded certificate"
                  draggable={false}
                />

                {placedFields.map((field) => (
                  <div
                    key={field.id}
                    className="certificate_drag_item"
                    style={{
                      left: `${field.x}%`,
                      top: `${field.y}%`,
                      width: `${field.width}%`,
                      minHeight: `${field.height}%`,
                      fontSize: field?.fontSize,
                      color: field?.textColor,
                      textAlign: field?.textAlign || "center",
                      transform:
                        field?.anchor === "center"
                          ? "translate(-50%, -50%)"
                          : "none",
                    }}
                    onMouseDown={(e) => onBoxMouseDown(e, field.id)}
                  >
                    {field.text}
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="certificate_modal_btn">
            <Button
              onClick={() => {
                const nameField = placedFields.find(
                  (o) => o.type === "studentName",
                );
                const dateField = placedFields.find(
                  (o) => o.type === "issueDate",
                );

                if (nameField && dateField) {
                  createCourseController.setFieldValue(
                    "certificate",
                    certificatePreview?.file,
                  );

                  createCourseController.setFieldValue("certificatePositions", {
                    name: {
                      x: nameField.x,
                      y: nameField.y,
                      width: nameField.width,
                      height: nameField.height,
                      fontSize: nameField.fontSize,
                      color: nameField.textColor,
                      align: nameField.textAlign || "center",
                      anchor: nameField.anchor || "center",
                    },
                    date: {
                      x: dateField.x,
                      y: dateField.y,
                      width: dateField.width,
                      height: dateField.height,
                      fontSize: dateField.fontSize,
                      color: dateField.textColor,
                      align: dateField.textAlign || "center",
                      anchor: dateField.anchor || "center",
                    },
                  });

                  setNewCertificateModal(false);
                  toast.success("Certificate sample created successfully");
                } else {
                  setShowValidation(true);
                }
              }}
            >
              Post
            </Button>
            <Button
              onClick={() => {
                setNewCertificateModal(false);
              }}
            >
              Cancel
            </Button>
          </div>
        </div>
      </Modal>
      {/* edit fontSize modal */}
      <Modal
        open={editFontSizeModal}
        onCancel={() => {
          setEditFontSizeModal(false);
        }}
        footer={null}
        className="certificateModal"
        closeIcon={null}
      >
        <div className="edit_var_modal_container">
          <div className="certificate_modal_title">
            <Button
              onClick={() => {
                setEditFontSizeModal(false);
              }}
            >
              <IoClose />
            </Button>
            <h3>Edit Font Size</h3>
          </div>
          <div className="edit_var_modal_content">
            <label>Font Size</label>
            <Select
              options={FontSizesEnum}
              value={selectedFieldId?.fontSize}
              onChange={(value) => {
                setSelectedFieldId({ ...selectedFieldId, fontSize: value });
              }}
              placeholder={"Select font size"}
            />
          </div>
          <div className="edit_var_modal_btn">
            <Button
              onClick={() => {
                let array = [...placedFields];
                array = array.map((o) => {
                  if (o.id == selectedFieldId.id) {
                    return { ...o, fontSize: selectedFieldId.fontSize };
                  } else {
                    return o;
                  }
                });
                setPlacedFields(array);
                setEditFontSizeModal(false);
              }}
            >
              Submit
            </Button>
          </div>
        </div>
      </Modal>
      {/* edit textColor modal */}
      <Modal
        open={editColorModal}
        onCancel={() => {
          setEditColorModal(false);
        }}
        footer={null}
        className="certificateModal"
        closeIcon={null}
      >
        <div className="edit_var_modal_container">
          <div className="certificate_modal_title">
            <Button
              onClick={() => {
                setEditColorModal(false);
              }}
            >
              <IoClose />
            </Button>
            <h3>Edit Text Color</h3>
          </div>
          <div className="edit_var_modal_content">
            <label>Text Color</label>
            <Input
              value={selectedFieldId?.textColor}
              onChange={(e) => {
                setSelectedFieldId({
                  ...selectedFieldId,
                  textColor: e.target.value,
                });
              }}
              placeholder={"Choose text color"}
              type="color"
            />
          </div>
          <div className="edit_var_modal_btn">
            <Button
              onClick={() => {
                let array = [...placedFields];
                array = array.map((o) => {
                  if (o.id == selectedFieldId.id) {
                    return { ...o, textColor: selectedFieldId.textColor };
                  } else {
                    return o;
                  }
                });
                setPlacedFields(array);
                setEditColorModal(false);
              }}
            >
              Submit
            </Button>
          </div>
        </div>
      </Modal>
    </Layout>
  );
};

export default NewCourse;
